module.exports = __webpack_public_path__ + "img/om.30bf4879.jpg";